<template>
  <section
    v-if="$route.fullPath != '/AboutUpstream'"
    id="core-about"
    @click="$router.push('/aboutUpstream')"
    style=""
  >
    <v-img
      v-if="$vuetify.breakpoint.mdAndUp"
      class="backgroundImg"
      :src="'https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/appImages%2Fabout_upstream.jpeg?alt=media&token=4e0ee90e-58d2-4c49-affa-9c4e4f2195b6'"
    >
      <div
        :class="{
          aboutSectionContainer: $vuetify.breakpoint.mdAndUp,
          aboutSectionContainerMobile: $vuetify.breakpoint.smAndDown,
        }"
      >
        <div class="aboutSectionHeader">
          <h1 class="my-0">About Upstream</h1>
        </div>
        <div class="aboutSectionParagraph">
          <p>
            {{ aboutParagraph }}
          </p>
        </div>
      </div>
    </v-img>
    <div v-else>
      <div
        class="aboutSectionContainerMobile"
        style="z-index: 2; position: relative"
      >
        <div class="aboutSectionHeader">
          <h1 class="my-0">About Upstream</h1>
        </div>
        <div class="aboutSectionParagraph">
          <p>
            {{ aboutParagraph }}
          </p>
        </div>
      </div>
      <v-img
        style="z-index: 1; position: relative; margin-top: -200px"
        class="backgroundImg"
        :src="'https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/appImages%2Fi__MUw8s.jpeg?alt=media&token=06e08079-ac84-498d-b89b-de596d327731'"
      >
      </v-img>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({ siteType: "general/siteType" }),
    aboutParagraph() {
      return "Upstream empowers customers to impact their community and strengthen the wellbeing of children and young people in Aotearoa. When you use a supplier through Upstream, this generates a portion of funding from the sale “we call an Upstream Contribution”. We then provide these funds towards Upstream Good Causes that support children and young people. It's a simple, sustainable way to support the next generation."
    },
  },
};
</script>


<style scoped>
.aboutSectionContainer {
  text-align: left;
  max-width: 75%;
  padding-top: 20px;
  padding-bottom: 45px;
  width: 400px;
  top: 20%;
  position: relative;
  left: 15%;
}

.aboutSectionContainerMobile {
  text-align: left;
  max-width: 90%;
  margin: auto;
  padding: 15px;
}

.aboutSectionHeader {
  text-align: center;
  margin-top: 15px;
  margin-bottom: 20px;
}

.aboutSectionParagraph {
}

.aboutSectionHeader h1 {
  color: #4cc7e8;
  text-align: left;
}
</style>

<style lang="scss">
#core-about {
  position: relative;
  min-width: 100vw;
  bottom: -12px;
  cursor: pointer;
  background: white;

  .backgroundImg {
    max-width: 1920px;
    margin: auto;
  }
}

.aboutSectionContainerMobile {
  .aboutSectionHeader h1 {
    text-align: left !important;
  }
}
</style>